// removed by extract-text-webpack-plugin
module.exports = {"container":"RecordingsTileView-container","loading":"RecordingsTileView-loading"};